// Guard against a second registration if the script is ever injected more than once
if (!customElements.get('virtual-sizer')) {
const MEASUREMENTS_STORAGE_KEY = 'bold_measurements';
class VirtualSizer extends HTMLElement {
  constructor() {
    super();

    this.formSettings = {
      heightInMin: 52,
      heightInMax: 82,
      weightLbsMin: 71,
      weightLbsMax: 422,
      ageMin: 13,
      ageMax: 89,
      braSizes: {
        us: {
          band: ['28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56'],
          cup: ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'],
        },
        au: {
          band: ['6', '8', '10', '12', '14', '16', '18', '20', '22', '24', '26', '28', '30', '32', '34'],
          cup: ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ', 'K'],
        },
        gb: {
          band: ['28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56'],
          cup: ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ', 'K'],
        },
        eu: {
          band: ['60', '65', '70', '75', '80', '85', '90', '95', '100', '105', '110', '115', '120', '125', '130'],
          cup: ['AA', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'],
        },
      },
    };

    this.formSettings.heighttFtMin = Math.floor(this.formSettings.heightInMin / 12);
    this.formSettings.heighttFtMax = Math.floor(this.formSettings.heightInMax / 12);

    this.formSettings.weightKgsMin = Math.ceil(this.formSettings.weightLbsMin * 0.45);
    this.formSettings.weightKgsMax = Math.floor(this.formSettings.weightLbsMax * 0.45);

    this.setAnonId();
  }

  setAnonId() {
    const sessionStorageKey = 'bold_anon_id';
    const bmAnonId =  getCookie("bm");
    if(bmAnonId && bmAnonId.length > 0){
      this.anon_id = bmAnonId;
    }
    else {
      this.anon_id = sessionStorage.getItem(sessionStorageKey)
    }

    if (!this.anon_id) {
      this.anon_id = Math.round(Math.random() * 100000000000);
      sessionStorage.setItem(sessionStorageKey, this.anon_id);
    }
  }

  connectedCallback() {
    this.goodRecs = null;
    this.modal = this.closest('modal-dialog');
    this.form = this.querySelector('form');
    this.sizeToggles = this.querySelectorAll('[name="size_toggle"]');
    this.showCmEls = this.querySelectorAll('[data-cm]');
    this.showInchEls = this.querySelectorAll('[data-inch]');
    this.screenButtons = this.querySelectorAll('[data-switch-screen]');

    this.inputs = {
      heighttM: this.querySelector('[name="height_m"]'),
      heightCm: this.querySelector('[name="height_cm"]'),
      heightFt: this.querySelector('[name="height_ft"]'),
      heightIn: this.querySelector('[name="height_in"]'),
      weightLbs: this.querySelector('[name="weight_lb"]'),
      weightKgs: this.querySelector('[name="weight_kg"]'),
      age: this.querySelector('[name="age"]'),
      braBand: this.querySelector('[name="bra_band"]'),
      braCup: this.querySelector('[name="bra_cup"]'),
      desired_garment_type: this.querySelector('[name="desired_garment_type"]'),
    };

    this.results = {
      bestSizeEl: this.querySelector('[data-best-size]'),
      bestFit: this.querySelector('[data-best-fit]'),
      fitUpper: this.querySelector('[data-fit="upper"]'),
      fitLower: this.querySelector('[data-fit="lower"]'),
      hipFits: this.querySelectorAll('[data-fit-hip]'),
      waistFits: this.querySelectorAll('[data-fit-waist]'),
      chestFits: this.querySelectorAll('[data-fit-chest]'),
      goodMatches: this.querySelector('[data-good-matches]'),
      dimensions: this.querySelector('[data-dimensions]'),
      customer: this.querySelector('[data-customer]'),
      acceptButtons: this.querySelectorAll('[data-accept-button]'),
      otherSizesEl: this.querySelector('[data-other-sizes]'),
    };

    this.buttons = {
      findRecSizeBtns: document.querySelectorAll("button[data-vsizer-btn]"),
      submitButtons: this.form.querySelectorAll('button[type="submit"]'),
    };

    this.mode = this.dataset.mode || 'product';
    this.syncUrl = this.dataset.syncUrl || null;
    this.customerId = this.dataset.customerId || null;
    this.errorEl = this.querySelector('[data-sizer-error]');
    this.saved = this.readSavedMeasurements();

    this.addEventHandlers();
    this.applyPreferredSizeUnit();
    this.populateBra(this.getCountryBraLocale());
    // Profile measurements win; localStorage only fills fields still empty (guests, and the A/B form restore)
    this.prefillForm();
    this.prefillMeasurements();
    this.updateSubmitState();
    this.selectPreferedSize();
    this.autoRecommend();

    // The account panel is rendered from the metafield, so once a save has gone through any way of
    // closing the modal (X, overlay, Escape, "Select this size") reloads to show the new values
    if (this.mode === 'account') {
      document.addEventListener('modalClosed', () => {
        if (this.savedThisSession) window.location.reload();
      });
    }
  }

  // aria-disabled rather than disabled so a click still reaches form-validation and shows which field is missing
  updateSubmitState() {
    const ready = this.form.checkValidity();
    for (const button of this.buttons.submitButtons) {
      button.setAttribute('aria-disabled', String(!ready));
    }
  }

  readSavedMeasurements() {
    const script = this.querySelector('[data-saved-measurements]');
    if (!script) return null;
    try {
      const saved = JSON.parse(script.textContent);
      return saved && saved.height_in ? saved : null;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  // A change to the saved measurements invalidates any size cached from the previous ones
  get savedStamp() {
    if (!this.saved) return null;
    return this.saved.updated_at || JSON.stringify(this.saved);
  }

  prefillForm() {
    if (!this.saved) return;
    const saved = this.saved;
    const unit = saved.unit === 'inch' ? 'inch' : 'cm';

    this.sizeToggles.forEach((toggle) => toggle.classList.toggle('is-active', toggle.value === unit));
    this.setSizeUnit(unit);

    if (unit === 'inch') {
      this.inputs.heightFt.value = Math.floor(saved.height_in / 12);
      this.inputs.heightIn.value = saved.height_in % 12;
      this.inputs.weightLbs.value = saved.weight_lb;
    } else {
      this.inputs.heightCm.value = saved.height_cm || Math.round(saved.height_in * 2.54);
      this.inputs.weightKgs.value = saved.weight_kg || Math.round(saved.weight_lb / 2.2046226218);
    }
    this.inputs.age.value = saved.age || '';

    // Bra scales differ per store (AU 6-34, US/GB 28-56), so only restore a bra saved on the same scale
    if (this.inputs.braBand && saved.bra_band && saved.bra_locale === this.form.locale.value) {
      this.inputs.braBand.value = saved.bra_band;
      this.inputs.braCup.value = saved.bra_cup || '';
    }
  }

  // The form is rendered per product, so entered values are kept in localStorage and restored on
  // the next PDP; empty fields only, so a value typed before the script ran is never overwritten
  prefillMeasurements() {
    let saved;
    try {
      saved = JSON.parse(window.localStorage.getItem(MEASUREMENTS_STORAGE_KEY) || 'null');
    } catch (e) {
      return;
    }
    if (!saved) return;

    if (saved.unit && this.querySelector('[name="size_toggle"].is-active')?.value !== saved.unit) {
      for (const sizeToggle of this.sizeToggles) {
        sizeToggle.classList.toggle('is-active', sizeToggle.value === saved.unit);
      }
      this.setSizeUnit(saved.unit);
    }

    for (const key of ['height_cm', 'height_ft', 'height_in', 'weight_kg', 'weight_lb', 'age']) {
      const input = this.form.elements[key];
      if (input && !input.value && saved[key]) input.value = saved[key];
    }
    // Bra scales differ per store (AU 6-34, US/GB 28-56), so only restore a bra saved on the same scale
    if (saved.bra_locale === this.form.locale.value) {
      for (const key of ['bra_band', 'bra_cup']) {
        const select = this.form.elements[key];
        if (select && !select.value && saved[key] && Array.from(select.options).some((o) => o.value === saved[key])) {
          select.value = saved[key];
        }
      }
    }
  }

  storeMeasurements(form) {
    const data = {
      unit: this.querySelector('[name="size_toggle"].is-active')?.value === 'inch' ? 'inch' : 'cm',
      bra_locale: form.locale.value,
    };
    for (const key of ['height_cm', 'height_ft', 'height_in', 'weight_kg', 'weight_lb', 'age', 'bra_band', 'bra_cup']) {
      if (form.elements[key] && form.elements[key].value) data[key] = form.elements[key].value;
    }
    try {
      window.localStorage.setItem(MEASUREMENTS_STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  selectPreferedSize(){
    if (this.mode !== 'product') return;
    try{
      const localStorageVal = window.localStorage.getItem(SIZE_PREFS_KEY);
      const sizePrefObj =  localStorageVal ? JSON.parse(localStorageVal) : {};
      const prefSize = sizePrefObj[this.inputs.desired_garment_type.value];
      if(prefSize && prefSize.length > 0){
        // MSK-234: on the MSK-T001 treatment template (sizer inside the sizing-help modal) the stored
        // recommendation only updates the labels. Selecting a variant here runs on page load for
        // returning customers, before Shoplift has settled, so leave the selection to the customer.
        const isSizingHelpTreatment = !!this.closest('.sizing-help');
        if(!isSizingHelpTreatment && !window.location.search.includes("variant=")){
          this.applyProductSize(prefSize);
        }
        // Labels only. Writing the measurements stamp here would make autoRecommend skip a refetch
        // after the saved profile changed.
        this.setRecommendedSizeLabel(prefSize);
      }
    }
    catch(e){
      console.error(e);
    }
  }

  disconnectedCallback() {}

  addEventHandlers() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.form.addEventListener('input', this.updateSubmitState.bind(this));
    this.form.addEventListener('change', this.updateSubmitState.bind(this));

    for (const acceptButton of this.results.acceptButtons) {
      acceptButton.addEventListener('click', this.onAcceptClick.bind(this));
    }

    for (const sizeToggle of this.sizeToggles) {
      sizeToggle.addEventListener('click', this.onSizeToggleClick.bind(this));
    }

    for (const button of this.screenButtons) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.switchScreen(event.target.dataset.switchScreen);
      });
    }

    this.inputs.heightFt.addEventListener('change', (event) => {
      let maxInch = 11;
      if (parseInt(this.inputs.heightFt.value) === this.formSettings.heighttFtMax) {
        maxInch = this.formSettings.heightInMax % 12;
        console.log('maxInch', maxInch);
      }
      this.inputs.heightIn.setAttribute('max', maxInch);
    });
  }

  onAcceptClick(event) {
    this.modal?.hide();
    this.switchScreen('form');
    if (this.mode === 'account' || !this.activeSizeRec) return;
    this.applyRecommendedSize(this.activeSizeRec, { scroll: true });

    // Logged-in customers keep their measurements on their profile so every PDP can recommend
    if (this.syncUrl && this.pendingMeasurements) {
      const size = this.activeSizeRec;
      this.saveMeasurements(this.pendingMeasurements)
        // saving clears cached sizes (they came from the old measurements); keep the one just chosen
        .then(() => this.storeSizePreference(size))
        .catch((error) => console.error('Measurements sync failed', error));
    }
  }

  // Legacy links become "Your Recommended Size: X"; MSK-T001 variant links keep their icon and
  // label, and only elements opted in with [data-rec-size-label] (mobile links, desktop "Size"
  // heading) take the recommended size.
  setRecommendedSizeLabel(size) {
    const label = `${window.themeStrings.recommendedSizeFilled} ${size}`;
    this.buttons.findRecSizeBtns.forEach((btn) => {
      if (btn.hasAttribute('data-sizing-help')) return;
      btn.innerText = label;
    });
    document.querySelectorAll('[data-rec-size-label]').forEach((el) => {
      el.textContent = label;
    });
  }

  applyRecommendedSize(size, { scroll = false } = {}) {
    this.storeSizePreference(size);
    if (this.savedStamp) window.localStorage.setItem(SIZE_PREFS_STAMP_KEY, this.savedStamp);

    if (!window.location.href.includes('?variant=') || scroll) {
      this.applyProductSize(size, { scroll });
    }
    this.setRecommendedSizeLabel(size);
  }

  // PDP: a customer with saved measurements gets their size without opening the modal
  autoRecommend() {
    if (this.mode !== 'product' || !this.saved) return;

    try {
      const prefs = JSON.parse(window.localStorage.getItem(SIZE_PREFS_KEY) || '{}');
      const stamp = window.localStorage.getItem(SIZE_PREFS_STAMP_KEY);
      if (prefs[this.inputs.desired_garment_type.value] && stamp === this.savedStamp) return;
    } catch (e) {
      console.error(e);
    }

    const data = {
      product_id: this.form.product_id.value,
      desired_garment_type: this.inputs.desired_garment_type.value,
      height_in: this.saved.height_in,
      weight_lb: this.saved.weight_lb,
      age: this.saved.age,
      locale: this.form.locale.value,
    };
    if (this.saved.bra_band && this.saved.bra_cup && this.saved.bra_locale === data.locale) {
      data.bra_band = this.saved.bra_band;
      data.bra_cup = this.saved.bra_cup;
    }

    this.fetchRecommendation(data)
      .then((response) => {
        const matches = response?.size_recommendations?.good_matches;
        if (!matches || !matches.length) return;
        // Best match first, but only a size this product actually has
        const match = matches.find((m) => this.productHasSize(m.garment.size)) || matches[0];
        this.applyRecommendedSize(match.garment.size);
      })
      .catch((error) => console.error('Auto size recommendation failed', error));
  }

  collectMeasurements(form) {
    const unit = this.querySelector('[name="size_toggle"].is-active')?.value === 'inch' ? 'inch' : 'cm';
    const data = { unit };

    if (unit === 'inch') {
      data.height_in = parseInt(form.height_ft.value) * 12 + parseInt(form.height_in.value);
      data.weight_lb = parseInt(form.weight_lb.value);
    } else {
      data.height_cm = parseInt(form.height_cm.value);
      data.weight_kg = parseInt(form.weight_kg.value);
      data.height_in = Math.round(data.height_cm * 0.3937007874);
      data.weight_lb = Math.round(data.weight_kg * 2.2046226218);
    }
    data.age = parseInt(form.age.value);

    if (form.bra_band && form.bra_cup && form.bra_band.value && form.bra_cup.value) {
      data.bra_band = form.bra_band.value;
      data.bra_cup = form.bra_cup.value;
      data.bra_locale = form.locale.value;
    }
    return data;
  }

  saveMeasurements(data) {
    if (!this.syncUrl) return Promise.reject(new Error('No measurements sync endpoint configured'));

    const body = new FormData();
    body.append('customer_id', this.customerId || '');
    ['unit', 'height_in', 'weight_lb', 'height_cm', 'weight_kg', 'age', 'bra_band', 'bra_cup', 'bra_locale'].forEach((key) => {
      if (data[key] !== undefined && data[key] !== null && data[key] !== '') body.append(key, data[key]);
    });

    return fetch(this.syncUrl, { method: 'POST', body, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Measurements sync responded ${response.status}`);
        return response.json();
      })
      .then((result) => {
        // The app proxy returns 200 for every branch of the task, so the body's status is the real outcome
        if (!result || result.status !== 'ok') throw new Error(`Measurements sync failed: ${result && result.status}`);
        // Sizes cached from the previous measurements no longer apply
        window.localStorage.removeItem(SIZE_PREFS_KEY);
        window.localStorage.removeItem(SIZE_PREFS_STAMP_KEY);
        return result;
      });
  }

  storeSizePreference(preferedRecSize){
    try{
      const localStorageVal = window.localStorage.getItem(SIZE_PREFS_KEY);
      const sizePrefObj =  localStorageVal ? JSON.parse(localStorageVal) : {};
      sizePrefObj[this.inputs.desired_garment_type.value] = preferedRecSize;
      window.localStorage.setItem(SIZE_PREFS_KEY, JSON.stringify(sizePrefObj));
    }
    catch(e){
      console.error(e);
    }
  }



  isSizeOptionName(name) {
    if (!name) return false;
    const n = name.toUpperCase();
    return n === 'SIZE' || n === 'OPTIONS[SIZE]';
  }

  getProductSizeValues() {
    const values = new Set();
    document.querySelectorAll('input[type="radio"]').forEach((el) => {
      if (this.isSizeOptionName(el.name) && el.value) values.add(el.value);
    });
    document.querySelectorAll('select').forEach((select) => {
      if (!this.isSizeOptionName(select.name)) return;
      [...select.options].forEach((option) => {
        if (option.value) values.add(option.value);
      });
    });
    return values;
  }

  productHasSize(size) {
    return this.getProductSizeValues().has(size);
  }

  applyProductSize(size, { scroll = false } = {}) {
    const radio = [...document.querySelectorAll('input[type="radio"]')].find(
      (el) => this.isSizeOptionName(el.name) && el.value === size
    );
    if (radio) {
      radio.click();
      if (scroll) radio.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const select = [...document.querySelectorAll('select')].find((el) => this.isSizeOptionName(el.name));
    if (!select) return;
    const hasOption = [...select.options].some((option) => option.value === size);
    if (!hasOption) return;

    select.value = size;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    if (scroll) {
      (select.closest('custom-select') || select).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  getVisitorCountry() {
    const fromForm = this.form.country_code?.value;
    const fromShopify = window.Shopify?.country;
    return String(fromForm || fromShopify || 'au').toLowerCase();
  }

  prefersImperialUnit(country = this.getVisitorCountry()) {
    return ['us', 'ca', 'lr', 'mm', 'pr', 'gu', 'vi', 'as', 'mp'].includes(country);
  }

  applyPreferredSizeUnit() {
    const unit = this.prefersImperialUnit() ? 'inch' : 'cm';
    for (const toggle of this.sizeToggles) {
      const active = toggle.value === unit;
      toggle.classList.toggle('is-active', active);
      toggle.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    this.setSizeUnit(unit);
  }

  getCountryBraLocale(country = this.getVisitorCountry()) {
    const au = new Set(['au', 'nz']);
    const gb = new Set([
      'gb', 'ie', 'za', 'sg', 'my', 'hk', 'in', 'ae', 'qa', 'kw', 'bh', 'om',
      'ng', 'ke', 'gh', 'pk', 'bd', 'lk',
    ]);
    const us = new Set([
      'us', 'ca', 'mx', 'pr', 'gt', 'hn', 'sv', 'ni', 'cr', 'pa', 'do', 'ht',
      'cu', 'co', 'pe', 'cl', 'ar', 'ec', 'uy', 'py', 'bo', 've', 'ph', 'jm',
      'tt', 'bs', 'bb',
    ]);
    if (au.has(country)) return 'au';
    if (gb.has(country)) return 'gb';
    if (us.has(country)) return 'us';
    return 'eu';
  }

  getBraLocaleForUnit(unit) {
    const countryLocale = this.getCountryBraLocale();
    if (countryLocale === 'au') return 'au';
    if (unit === 'inch') return countryLocale === 'gb' ? 'gb' : 'us';
    if (unit === 'cm') return 'eu';
    return countryLocale;
  }

  getActiveSizeUnit() {
    return this.querySelector('[name="size_toggle"].is-active')?.value || 'cm';
  }

  braHintIsRelevant(locale, unit = this.getActiveSizeUnit()) {
    if (locale === 'au') return true;
    if (locale === 'eu') return unit === 'inch';
    if (locale === 'us' || locale === 'gb') return unit === 'cm';
    return false;
  }

  populateBra(locale) {
    const sizes = this.formSettings.braSizes[locale] || this.formSettings.braSizes.au;
    if (this.form.locale) this.form.locale.value = locale;

    const unitLabel = { au: 'AU', us: 'in', gb: 'in', eu: 'cm' }[locale] || 'AU';
    const hintKey = { au: 'braHintAu', us: 'braHintUs', gb: 'braHintGb', eu: 'braHintEu' }[locale];
    const hint = hintKey ? this.dataset[hintKey] : '';
    const showHint = Boolean(hint) && this.braHintIsRelevant(locale);

    if (this.inputs.braBand) {
      this.inputs.braBand.dataset.placeholder = `Band (${unitLabel})`;
      this.populateSelect(this.inputs.braBand, sizes.band);
      this.inputs.braBand.setAttribute(
        'aria-describedby',
        showHint ? 'Error-VirtualSizerBra BraSystemHint' : 'Error-VirtualSizerBra'
      );
    }
    if (this.inputs.braCup) {
      this.populateSelect(this.inputs.braCup, sizes.cup);
    }

    const unitEl = this.querySelector('[data-bra-band-unit]');
    if (unitEl) unitEl.textContent = unitLabel ? ` (${unitLabel})` : '';

    const hintEl = this.querySelector('[data-bra-system-hint]');
    if (hintEl) {
      hintEl.textContent = showHint ? hint : '';
      hintEl.hidden = !showHint;
    }
  }

  populateSelect(select, valsArr, min, max) {
    if (!select || select.nodeName !== 'SELECT') return;
    let markup = ``;
    if (min && max) {
      for (let i = min; i < max + 1; i++) {
        markup += this.getOptionMarkup(i);
      }
    } else if (valsArr) {
      for (const val of valsArr) {
        markup += this.getOptionMarkup(val);
      }
    }
    if (select.dataset.placeholder !== undefined) {
      markup = `<option disabled selected value="">${select.dataset.placeholder}</option>${markup}`;
    }
    select.innerHTML = markup;
  }

  getOptionMarkup(val, label) {
    return `<option value="${val}">${label ? label : val}</option>`;
  }

  setSizeUnit(val) {
    if (!val) {
      val = this.querySelector('[name="size_toggle"].is-active').value;
    }

    const isCm = !!(val === 'cm');

    this.showCmEls.forEach((x) => {
      x.hidden = !isCm;
      x.querySelectorAll('input, select').forEach((y) => (y.disabled = !isCm));
    });

    this.showInchEls.forEach((x) => {
      x.hidden = isCm;
      x.querySelectorAll('input, select').forEach((y) => (y.disabled = isCm));
    });
  }

  // Carry entered values across the unit switch instead of clearing them
  convertUnits(toUnit) {
    const { heightCm, heightFt, heightIn, weightLbs, weightKgs } = this.inputs;

    if (toUnit === 'inch') {
      if (heightCm.value) {
        const totalIn = Math.round(parseInt(heightCm.value) * 0.3937007874);
        heightFt.value = Math.floor(totalIn / 12);
        heightIn.value = totalIn % 12;
      }
      if (weightKgs.value) weightLbs.value = Math.round(parseInt(weightKgs.value) * 2.2046226218);
    } else {
      if (heightFt.value) {
        heightCm.value = Math.round((parseInt(heightFt.value) * 12 + (parseInt(heightIn.value) || 0)) * 2.54);
      }
      if (weightLbs.value) weightKgs.value = Math.round(parseInt(weightLbs.value) / 2.2046226218);
    }
  }

  onSizeToggleClick(event) {
    event.preventDefault();

    const thisToggle = event.target;
    if (thisToggle.classList.contains('is-active')) return;

    for (const sizeToggle of this.sizeToggles) {
      sizeToggle.classList.remove('is-active');
      sizeToggle.setAttribute('aria-pressed', 'false');
    }

    thisToggle.classList.add('is-active');
    this.convertUnits(thisToggle.value);
    thisToggle.setAttribute('aria-pressed', 'true');
    this.setSizeUnit(thisToggle.value);
    this.populateBra(this.getBraLocaleForUnit(thisToggle.value));
    this.updateSubmitState();
  }

  onFormSubmit(event) {
    event.preventDefault();

    const form = event.target;

    if (!form.checkValidity()) {
      return;
    }

    this.storeMeasurements(form);

    const measurements = this.collectMeasurements(form);
    if (this.errorEl) this.errorEl.hidden = true;

    const data = {
      product_id: form.product_id.value,
      desired_garment_type: form.desired_garment_type.value,
      height_in: measurements.height_in,
      weight_lb: measurements.weight_lb,
      age: measurements.age,
      locale: form.locale.value,
    };

    if (measurements.bra_band && measurements.bra_cup) {
      data.bra_band = measurements.bra_band;
      data.bra_cup = measurements.bra_cup;
    }

    // Account mode saves first, then shows the same recommendation screen the PDP does, sized
    // against the generic tops garment since there is no product on the page
    if (this.mode === 'account') {
      this.switchScreen('loading');
      this.saveMeasurements(measurements)
        .then(() => {
          this.savedThisSession = true;
          this.makeAPICall(data);
        })
        .catch((error) => {
          console.error('Measurements save failed', error);
          this.switchScreen('form');
          if (this.errorEl) this.errorEl.hidden = false;
        });
      return;
    }

    // Kept until the customer accepts a size, then synced to their profile
    this.pendingMeasurements = measurements;

    this.makeAPICall(data);
  }

  fetchRecommendation(data) {
    const params = new URLSearchParams({
      client_id: 'meshki',
      user_key: '7621d5ba3d5ba47e9583290641dffb95fffb96025e79f70b',
      desired_brand: 'meshki',
      age: data.age,
      height: data.height_in,
      weight: data.weight_lb,
      anon_id: this.anon_id || 'TEST',
      desired_garment_type: data.desired_garment_type,
      locale: data.locale,
    });

    if (data.product_id) params.append('product_id', data.product_id);

    if (data.bra_band && data.bra_cup) {
      params.append('bra_size', `${data.bra_band}${data.bra_cup}`);
    }

    return fetch(`https://api.boldmetrics.io/virtualsizer/get?${params.toString()}`).then((response) => response.json());
  }

  makeAPICall(data) {
    this.switchScreen('loading');

    this.fetchRecommendation(data)
      .then((response) => {
        if (response.code !== 200) {
          console.error(response);
          return this.switchScreen('no-results');
        }
        this.showResults(response);
        this.sendProductUpdateEvent(response);
      })
      .catch((error) => {
        console.error(error);
        this.switchScreen('no-results');
      });
  }

  toTitleCase(str) {
    if (!str) return '';
    return str.split(' ').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }

  populateLabels(fit_description) {
    // toggle upper/lower screen vis
    if (fit_description.chest_circum) {
      this.results.fitLower.hidden = true;
      this.results.fitUpper.hidden = false;
    } else {
      this.results.fitLower.hidden = false;
      this.results.fitUpper.hidden = true;
    }
    for (const label of this.results.chestFits) {
      label.innerHTML = this.toTitleCase(fit_description.chest_circum);
    }
    for (const label of this.results.hipFits) {
      label.innerHTML = this.toTitleCase(fit_description.hip_circum);
    }
    for (const label of this.results.waistFits) {
      label.innerHTML = this.toTitleCase(fit_description.waist_circum_stomach || fit_description.waist_circum_natural || fit_description.waist_circum_preferred);
    }
  }

  showResults(data) {
    this.goodRecs = data.size_recommendations.good_matches;
    console.log('good_matches', this.goodRecs);
    
    if (!this.goodRecs) {
      return this.switchScreen('no-results');
    }

    // Prefer the best match the product actually stocks, so the headline never names an unavailable size
    const bestRec =
      this.goodRecs.find((m) => this.productHasSize(m.garment.size)) ||
      this.goodRecs[0];

    this.activeSizeRec = bestRec.garment.size;
    this.results.bestSizeEl.innerHTML = bestRec.garment.size;
    this.populateLabels(bestRec.fit_description);

    let markup = '';

    //sort
    try {
      const sizeOrder = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "3XL"];
      
      this.goodRecs.sort(function(a, b) {
        const sizeA = a.garment.size;
        const sizeB = b.garment.size;


        const isNumericA = !isNaN(sizeA);
        const isNumericB = !isNaN(sizeB);

        if (isNumericA && isNumericB) {
          return Number(sizeA) - Number(sizeB);
        } else if (!isNumericA && !isNumericB) {
          return sizeOrder.indexOf(sizeA) - sizeOrder.indexOf(sizeB);
        } else {
          return isNumericA ? -1 : 1;
        }
      });
    } catch(e) {
      console.error(e);
    }
    //end sort

    if (this.mode === 'product') {
      this.goodRecs.forEach((match) => {
        if (!this.productHasSize(match.garment.size)) return;
        const isBest = match.garment.size === bestRec.garment.size;
        const stateClass = isBest ? ' is-active' : '';
        markup += `<li><button type="button" class="pill-button pill-button--large${stateClass}" aria-pressed="${isBest}">${match.garment.size}</button></li>`;
      });
    }
    this.results.otherSizesEl.innerHTML = markup;
    const variantsWrap = this.results.otherSizesEl.closest('.size-guide__variants');
    if (variantsWrap) variantsWrap.hidden = !markup;

    // handle size button clicks
    const sizeButtons = this.results.otherSizesEl.querySelectorAll('button');
    for (const button of sizeButtons) {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const buttonEl = event.currentTarget;
        const activeSize = buttonEl.innerText.trim();
        const rec = this.goodRecs.find(x => x.garment.size === activeSize);
        if (!rec) return;

        this.activeSizeRec = activeSize;
        this.populateLabels(rec.fit_description);

        for (const x of sizeButtons) {
          x.classList.remove('is-active');
          x.setAttribute('aria-pressed', 'false');
        }
        buttonEl.classList.add('is-active');
        buttonEl.setAttribute('aria-pressed', 'true');
      });
    }

    this.switchScreen('results');
  }

  switchScreen(name) {
    const targetScreen = this.querySelector(`[data-sizer-screen="${name}"]`);
    if (!targetScreen) return;
    this.screens = this.querySelectorAll('[data-sizer-screen]');
    for (const screen of this.screens) {
      screen.hidden = true;
    }
    targetScreen.hidden = false;

    const heading = targetScreen.querySelector('.h5, h1, h2, h3, h4') || targetScreen;
    window.a11y?.focusTarget(heading);
  }

  sendProductUpdateEvent(response) {
    document.dispatchEvent(
        new CustomEvent('bmi-recommendation-sent', {
            bubbles: true,
            detail: {
                api: response,
            },
        })
    )
  }
}

customElements.define('virtual-sizer', VirtualSizer);
}
